import { DOC_UPLOAD_CATEGORIES, DOC_UPLOAD_FORM_INPUT_IDS, DOC_UPLOAD_REQUIRED_PAGES } from "../enums/common";
import { FormInputItem, SelectOption } from "../types/common";

export const DocUploadSelectCategory: SelectOption[] = [
  {
    displayValue: "Mandatory",
    value: DOC_UPLOAD_CATEGORIES.MANDATORY,
    translationKey: "Checklist-docUpload-category-mandatory",
  },
  {
    displayValue: "Non Mandatory",
    value: DOC_UPLOAD_CATEGORIES.NON_MANDATORY,
    translationKey: "Checklist-docUpload-category-non-mandatory",
  },
];

export const DocUploadSelectOptions: SelectOption[] = [
  {
    category: DOC_UPLOAD_CATEGORIES.MANDATORY,
    displayValue: "MANDATORY - Driver's License",
    value: "driver-license",
    translationKey: "Checklist-docUpload-driver-license",
    requiredPages: [DOC_UPLOAD_REQUIRED_PAGES.FRONT, DOC_UPLOAD_REQUIRED_PAGES.BACK],
  },
  {
    category: DOC_UPLOAD_CATEGORIES.MANDATORY,
    displayValue: "MANDATORY - Passport",
    value: "passport",
    translationKey: "Checklist-docUpload-driver-passport",
    requiredPages: [DOC_UPLOAD_REQUIRED_PAGES.BACK],
  },
  {
    category: DOC_UPLOAD_CATEGORIES.NON_MANDATORY,
    displayValue: "NON_MANDATORY - Permanent Resident's Card",
    value: "resident-card",
    translationKey: "Checklist-docUpload-resident-card",
    requiredPages: [DOC_UPLOAD_REQUIRED_PAGES.FRONT, DOC_UPLOAD_REQUIRED_PAGES.BACK],
  },
  {
    category: DOC_UPLOAD_CATEGORIES.NON_MANDATORY,
    displayValue: "NON_MANDATORY - Foreign Passport",
    value: "foreign-passport",
    translationKey: "Checklist-docUpload-foreign-passport",
    requiredPages: [DOC_UPLOAD_REQUIRED_PAGES.BACK],
  },
];

export interface DocUploadFormInputItem extends FormInputItem {
  id: DOC_UPLOAD_FORM_INPUT_IDS;
  value: string;
}

export const DocUploadsListConfig: DocUploadFormInputItem[] = [
  {
    value: "",
    hasError: false,
    required: true,
    label: "Select the document category to get started",
    labelTranslationKey: "Checklist-docUpload-category-select-label",
    errorMessage: "Please select the document category",
    errorMessageTranslationKey: "Checklist-docUpload-category-select-error",
    id: DOC_UPLOAD_FORM_INPUT_IDS.SELECT_DOCUMENT_CATEGORY,
    name: "docUploadSelectCategory",
    dataKey: "docUploadSelectCategory",
    type: "select",
    selectOptions: DocUploadSelectCategory,
    placeholder: "Select document category",
    placeholderTranslationKey: "Checklist-docUpload-category-select-placeholder",
  },
  {
    value: "",
    hasError: false,
    required: true,
    label: "Select the document",
    labelTranslationKey: "Checklist-docUpload-select-item-label",
    errorMessage: "Please select the document",
    errorMessageTranslationKey: "Checklist-docUpload-select-item-error",
    id: DOC_UPLOAD_FORM_INPUT_IDS.SELECT_DOCUMENT_ITEM,
    name: "docUploadSelectOptions",
    dataKey: "docUploadSelectOptions",
    type: "select",
    selectOptions: DocUploadSelectOptions,
    placeholder: "Select document item",
    placeholderTranslationKey: "Checklist-docUpload-select-item-placeholder",
  },
];
